import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AuthRedirectGuard } from './core/guards/auth-redirect.guard';
import { AdherentActifGuard } from './core/guards/adherent-actif.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('./features/dashboard/dashboard.module').then(
            (m) => m.DashboardModule
          ),
      },

      {
        path: 'fds',
        loadChildren: () =>
          import('./features/feuilles-soins/fds.module').then(
            (m) => m.FeuillesSoinsModule
          ),
      },
      {
        path: 'pecs',
        loadChildren: () =>
          import('./features/prise-charge/pec.module').then(
            (m) => m.PecModule
          ),
      },

      {
        path: 'afld',
        loadChildren: () =>
          import('./features/affectations-longue-duree/afld.module').then(
            (m) => m.AfldModule
          ),
      },
      {
        path: 'ep',
        loadChildren: () =>
          import('./features/ententes-prealables/ep.module').then(
            (m) => m.EntentesPrealablesModule
          ),
      },
      {
        path: 'ma-famille',
        loadChildren: () =>
          import('./features/ma-famille/ma-famille.module').then(
            (m) => m.MaFamilleModule
          ),
      },
      {
        path: 'adhesion',
        loadChildren: () =>
          import('./features/adhesion/adhesion.module').then(
            (m) => m.AdhesionModule
          ),
      },
      {
        path: 'cotisations',
        canActivate: [AdherentActifGuard],
        loadChildren: () =>
          import('./features/cotisations/cotisations.module').then(
            (m) => m.CotisationsModule
          ),
      },
      {
        path: 'reclamations',
        loadChildren: () => import('./features/reclamations/reclamations.module')
          .then(m => m.ReclamationsModule)
      },
      {
        path: 'assistance',
        loadChildren: () => import('./features/assistance/assistance.module')
          .then(m => m.AssistanceModule)
      },
      {
        path: 'mon-compte',
        loadChildren: () => import('./features/mon-compte/mon-compte.module')
          .then(m => m.MonCompteModule)
      }
    ],
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [AuthRedirectGuard],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'dashboard',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }